/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CreateCustomFieldPayload = {
    name: string;
    type: CreateCustomFieldPayload.type;
    required: boolean;
};
export namespace CreateCustomFieldPayload {
    export enum type {
        TEXT = 'text',
        TEXTAREA = 'textarea',
        DATE = 'date',
        CHECKBOX = 'checkbox',
        NUMBER = 'number',
    }
}

